import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import MuiSnackbar from '@mui/material/Snackbar'
import Alert from '@mui/material/Alert';
import { hideSnackbar } from './../redux/snackbar'

const INFO_SNACKBAR_AUTO_HIDE_DURATION = 5000;

const Snackbar = (props) => {

    const dispatch = useDispatch()
    const snackbar = useSelector(state => state.snackbar)

    const [open, setOpen] = useState(false);

    useEffect(() => {
        setOpen(snackbar.isOpen)
    }, [snackbar])

    const onClose = () => {
        setOpen(false)
    }

    const onExited = () => {
        dispatch(hideSnackbar())
    }

    return (
        <MuiSnackbar
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
            open={open}
            onClose={onClose}
            onExited={onExited}
            transitionDuration={{ enter: 150, exit: 150 }}
            autoHideDuration={INFO_SNACKBAR_AUTO_HIDE_DURATION}
        >
            <Alert
                severity={snackbar.type || 'success'}
                elevation={6}
                onClose={onClose}
            >
                {snackbar.message}
            </Alert>

        </MuiSnackbar>
    )
}

export default Snackbar